module.exports = __webpack_public_path__ + "img/logo.95cdb3b0.png";